export default
{
    path: "/AnnualleaveHistory",
    component: () => import('../view/AnnualleaveHistory/index.vue'),
    props: (route) => ({
        token:route.query.token,
        userId:route.query.userId,
        secondLoginType:route.query.secondLoginType,
        secondAssessToken:route.query.secondAssessToken,
        deviceId:route.query.deviceId,
    })
}



// WEBPACK FOOTER //
// ./src/router/AnnualleaveHistory.js